
/**
 * Coerces a data-bound value (typically a string) to a boolean.
 */
export function coerceBooleanProperty(value: any): boolean {
  // NOTE: Don't use `triple-equals` here for the null check.
  return value != null && `${value}` !== 'false';
}
